// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/base-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about estimated gas cost of a transaction on both L1 and L2
 * @export
 * @interface BaseGasEstimate
 */
export interface BaseGasEstimate {
    /**
     * 
     * @type {string}
     * @memberof BaseGasEstimate
     */
    gasLimit: string;
    /**
     * 
     * @type {string}
     * @memberof BaseGasEstimate
     */
    l1GasLimit: string;
}

/**
 * Check if a given object implements the BaseGasEstimate interface.
 */
export function instanceOfBaseGasEstimate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gasLimit" in value;
    isInstance = isInstance && "l1GasLimit" in value;

    return isInstance;
}

export function BaseGasEstimateFromJSON(json: any): BaseGasEstimate {
    return BaseGasEstimateFromJSONTyped(json, false);
}

export function BaseGasEstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseGasEstimate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gasLimit': json['gasLimit'],
        'l1GasLimit': json['l1GasLimit'],
    };
}

export function BaseGasEstimateToJSON(value?: BaseGasEstimate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gasLimit': value.gasLimit,
        'l1GasLimit': value.l1GasLimit,
    };
}

